@if (content) {
  <div>
    <div class="content-holder" [innerHTML]="content"></div>
  </div>
} @else {
  <p>Ładowanie informacji...</p>
}
